import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';

const FieldError = ({ error, ...rest }) => {
  return error ? (
    <Box bg="ui.errorBackground" color="greys.steel" fontSize={['sm', 'base']} p={2} data-testid="error" {...rest}>
      {error.message}
    </Box>
  ) : null;
};

FieldError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }),
};

FieldError.defaultProps = {
  error: null,
};

export default FieldError;
